<template>
	<b-row style="min-height: 100vh;" align-v="center" align-h="center">
		<div class="col-md-12 text-center">
			<span class="display-1 d-block">404</span>
			<div class="mb-4 lead">Etsimääsi sivua ei löytynyt.</div>
		</div>
	</b-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
